<template>

<div>
    <div class="container">

        <!-- Post Start -->
        <div v-for='(f,i) in feed' class="row d-flex justify-content-center mb-5">
            <div class="col-lg-10 d-flex justify-content-center">

                <div class="card card-feed">
                    <div class="card-header d-flex flex-column flex-sm-row align-items-center justify-content-center justify-content-sm-between">
                        <div class="model-profile d-flex align-items-center flex-column flex-sm-row">
                            <a :href="'/onlyfans-models/' + f.slug " class="model-thumb">
                                <img alt="Model Name" :src="f.avatar_thumb" class="img-fluid" >
                            </a>
                            <h3>
                                <a :href="'/onlyfans-models/' + f.slug ">{{ f.name }}</a>
                            </h3>                               
                        </div>

                        <div class="model-stats mt-2 mb-2">

                            <fav-btn :m='f.id' :l='f.likes'></fav-btn>

                            <span class="views mr-0">
                                <span class="icon icon-eye"></span>
                                {{ f.previews }}
                            </span>
                        </div>
                    </div>

                    <feed-content v-if='f.type == "image"' 
                                  :c='f.content' :s='f.slug' :i='i' :mn='f.name'></feed-content>

                    <feed-content-videos v-if='f.type == "video"' 
                                  :c='f.content' :s='f.slug' :i='i'></feed-content-videos>

                </div>

            </div>
        </div>

        <div v-if=' feed.length < total' class="row">
            <div class="col-12 d-flex justify-content-center">
                <button @click='getData()' 
                        class="btn btn-outline-primary" 
                        :disabled='isLoading'>
                    <span class="icon icon-rotate-cw"></span>
                    Load more
                </button>
            </div>
        </div>
        
    </div>

    <full-screen-player></full-screen-player>
</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        props : ['n'],

        created() {
            if( typeof this.n != 'undefined' ) {
                this.limited = parseInt(this.n);
            }
        },

        data() {
            return {
                isReady   : false,
                isLoading : false,
                total   : 0,

                limited : false,

                feed : []
            }
        },

        methods : {

            getData() {

                this.isLoading = true;

                var data = { s : this.feed.length };

                if( !this.isReady ) {
                    data.i = 1;
                }

                if( this.limited ) {
                    data.l = this.limited;
                }
                
                this.ajax.call('fd:gt', data, (r) => {

                    this.isLoading = false;

                    if( r.status == 'success' ) {

                        if( !this.isReady ) {
                        
                            this.isReady = true;
                            this.feed = r.data.r;
                            this.total = r.data.t;
                        
                        } else {

                            this.feed = this.feed.concat( r.data );
                        }


                    }

                })
            }

        },

        components : {
            'feed-content' : require('./FeedContent.vue').default,
            'feed-content-videos' : require('./FeedContentVideos.vue').default
        }

    }
</script>
